<template>
  <v-card>
    <v-card-text>
      <v-container grid-list-lg>
        <v-layout row>
          <v-flex xs12 md1>
            <v-text-field light outlined label="Folio"></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field light outlined label="Paciente"></v-text-field>
          </v-flex>
          <v-flex xs12 md2>
            <v-autocomplete light outlined label="Status"></v-autocomplete>
          </v-flex>
          <v-flex xs12 md2>
            <v-menu
              ref="fechaFin"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  v-on="on"
                  label="Fecha Fin"
                  slot="activator"
                  :value="formatDate(filtros.FechaFin)"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                @input="$refs.fechaFin.save(filtros.FechaFin)"
                locale="es-es"
                v-model="filtros.FechaFin"
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md2>
            <v-menu
              ref="fechaFin"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  v-on="on"
                  label="Fecha Fin"
                  slot="activator"
                  :value="formatDate(filtros.FechaFin)"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                @input="$refs.fechaFin.save(filtros.FechaFin)"
                locale="es-es"
                v-model="filtros.FechaFin"
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md1>
            <v-btn fab type="submit" color="primary" dark
              ><v-icon dark color="white">search</v-icon></v-btn
            >
          </v-flex>
        </v-layout>
        <v-layout row class="pt-3">
          <v-flex xs12>
            <v-data-table :items="solicitudes">
              <template slot="header">
                <tr class="mb-6">
                  <th width="100" class="primary--text text-left">
                    Folio
                  </th>
                  <th class="primary--text text-left">
                    Fecha
                  </th>
                  <th class="primary--text text-left">
                    Nombre Paciente
                  </th>
                  <th class="primary--text text-left">
                    Estatus
                  </th>
                </tr>
              </template>
              <template slot="item" slot-scope="scope">
                <tr>
                  <td>{{ scope.item.Folio }}</td>
                  <td>{{ scope.item.Fecha }}</td>
                  <td>{{ scope.item.Paciente }}</td>
                  <td>{{ scope.item.Estatus }}</td>
                </tr>
              </template>
              <template slot="no-data">
                No hay datos para mostrar
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      filtros: {},
      solicitudes: [
        {
          Folio: 1,
          Fecha: "12/02/2021",
          Paciente: "Jose Eduardo Pérez Martínez",
          Estatus: "Solicitud Creada",
        },
        {
          Folio: 1,
          Fecha: "12/02/2021",
          Paciente: "Jose Eduardo Pérez Martínez",
          Estatus: "Solicitud Creada",
        },
        {
          Folio: 1,
          Fecha: "12/02/2021",
          Paciente: "Jose Eduardo Pérez Martínez",
          Estatus: "Solicitud Creada",
        },
        {
          Folio: 1,
          Fecha: "12/02/2021",
          Paciente: "Jose Eduardo Pérez Martínez",
          Estatus: "Solicitud Creada",
        },
        {
          Folio: 1,
          Fecha: "12/02/2021",
          Paciente: "Jose Eduardo Pérez Martínez",
          Estatus: "Solicitud Creada",
        },
        {
          Folio: 1,
          Fecha: "12/02/2021",
          Paciente: "Jose Eduardo Pérez Martínez",
          Estatus: "Solicitud Creada",
        },
        {
          Folio: 1,
          Fecha: "12/02/2021",
          Paciente: "Jose Eduardo Pérez Martínez",
          Estatus: "Solicitud Creada",
        },
      ],
    };
  },
  name: "Solicitudes",
};
</script>

<style></style>
